module.exports = __webpack_public_path__ + "img/Backfee.b681e45e.svg";